import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import MuiPageWrapper from '@/@mui/MuiPageWrapper';

import LoadingState from '@/components/LoadingState';

interface Props extends PropsWithChildren {
  sideContent?: React.ReactNode;
  isSideContentPermanent?: boolean;
  isLoading?: boolean;
  contentWidth?: string;
}

const ResetSplitMuiPage: React.FC<Props> = ({
  children,
  sideContent,
  isSideContentPermanent,
  isLoading,
  contentWidth = '22.5rem',
}) => {
  const theme = useTheme();
  const isDekstop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <MuiPageWrapper>
      {isLoading ? (
        <LoadingState />
      ) : (
        <Stack direction="row" width="100%">
          <Box
            sx={{
              flex: '1 0 50%',
              display: 'flex',
              backgroundColor: '#fff',
            }}
          >
            <Stack
              sx={{
                px: { xs: 2, md: 4 },
                width: '100%',
                flex: '1 1 100%',
              }}
            >
              <Stack
                sx={{
                  py: 5,
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                }}
                gap={5}
              >
                <Stack
                  sx={{
                    width: '100%',
                    maxWidth: contentWidth,
                  }}
                >
                  {children}
                </Stack>

                {!isDekstop && !!isSideContentPermanent && !!sideContent && (
                  <Stack
                    sx={{
                      width: '100%',
                    }}
                    alignItems="center"
                    justifyContent="center"
                  >
                    {sideContent}
                  </Stack>
                )}
              </Stack>
            </Stack>
          </Box>

          {isDekstop && !!sideContent && (
            <Box
              sx={{
                flex: '1 0 50%',
                display: 'flex',
                bgcolor: 'grey.100',
              }}
            >
              {sideContent}
            </Box>
          )}
        </Stack>
      )}
    </MuiPageWrapper>
  );
};

export default ResetSplitMuiPage;
